import React from 'react';

const DatePickerFilter = ({ startDate, endDate, setStartDate, setEndDate }) => {
  return (
    <div className="flex items-center gap-2 bg-white p-3 rounded-2xl shadow-sm border border-slate-200">
      <div className="flex flex-col px-1">
        <span className="text-[9px] font-black text-slate-300 uppercase ml-1">Début</span>
        <input 
          type="date" 
          value={startDate} 
          onChange={(e) => setStartDate(e.target.value)} 
          className="text-xs font-bold text-indigo-600 outline-none cursor-pointer bg-transparent" 
        />
      </div>

      <span className="text-slate-200 font-light mt-3">|</span>

      <div className="flex flex-col px-1">
        <span className="text-[9px] font-black text-slate-300 uppercase ml-1">Fin</span>
        <input 
          type="date" 
          value={endDate} 
          onChange={(e) => setEndDate(e.target.value)} 
          className="text-xs font-bold text-indigo-600 outline-none cursor-pointer bg-transparent" 
        />
      </div>
    </div>
  );
};

export default DatePickerFilter;